// Reglas del login compartidas por Login, DefinirPassword, Usuarios y Mi cuenta.
// La política de contraseña es la misma que aplica el API (Services/Auth/PasswordPolicy.cs):
// el front solo adelanta el aviso, quien decide es el servidor.

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 256;

// "" si la contraseña es válida; si no, el mensaje a mostrar.
export function validarPassword(password) {
    if (!password || !password.trim() || password.length < PASSWORD_MIN_LENGTH) {
        return `La contraseña debe tener al menos ${PASSWORD_MIN_LENGTH} caracteres.`;
    }
    if (password.length > PASSWORD_MAX_LENGTH) {
        return `La contraseña no puede superar los ${PASSWORD_MAX_LENGTH} caracteres.`;
    }
    return "";
}

// El código llega por email: al pegarlo suele traer espacios o guiones.
export function normalizarCodigo(valor) {
    return String(valor ?? "").replace(/\D/g, "").slice(0, 6);
}

export function mensajeErrorAuth(error, porDefecto) {
    const status = error?.response?.status;
    if (status === 429) {
        return "Demasiados intentos. Espera un minuto y vuelve a probar.";
    }
    return error?.response?.data?.message || porDefecto;
}
